
import React from 'react';

import Analyze2OpsubPageState from './Analyze2OpsubPage.state';

const Analyze2OpsubPage = (props) => {

    return (
        <Analyze2OpsubPageState
            match={props.match}
        />
    )
}

export default Analyze2OpsubPage;
